import React from "react";
import { Stack } from "@mui/material";

import { DialogButton, HubHookFormWrapper } from "../../components";

import ContactsLocationFilter from "../../pages/Companies/ContactsLocationFilter";
import OrganizationUsersStatusFilter from "./OrganizationUsersStatusFilter";
import OrganizationRoleFilter from "./OrganizationRoleFilter";

const OrganizationUsersBar = ({ disabled }) => {
  return (
    <HubHookFormWrapper onSubmit={() => {}} sx={{ width: "100%" }}>
      <Stack justifyContent="space-between" direction="row" width="100%">
        <Stack direction="row" gap="10px">
          <ContactsLocationFilter />
          <OrganizationUsersStatusFilter />
          <OrganizationRoleFilter />
        </Stack>
        <Stack direction="row" gap="10px">
          <DialogButton
            name="create-user"
            label="Invite User"
            variant="contained"
            size="xsmall"
            disabled={disabled}
          />
        </Stack>
      </Stack>
    </HubHookFormWrapper>
  );
};

export default OrganizationUsersBar;
